import { _decorator, Node, Component } from 'cc';
import { DEV } from 'cc/env';
import EnhanceAnimation from './EnhanceAnimation';

const { ccclass, property, requireComponent } = _decorator;

@ccclass('EnhanceAnimationTrigger')
@requireComponent(EnhanceAnimation)
export default class EnhanceAnimationTrigger extends Component {
    @property({ displayName: DEV && '事件名稱', tooltip: DEV && '事件名稱' })
    public readonly eventName: string = '';
    @property({ displayName: DEV && '指定事件目標', tooltip: DEV && '是否額外指定事件目標, 預設使用全域事件' })
    public readonly useEventTarget: boolean = false;
    @property({
        type: Node,
        visible(this: EnhanceAnimationTrigger) {
            return this.useEventTarget;
        },
        displayName: DEV && '事件目標',
        tooltip: DEV && '額外指定事件目標, 可指定任意節點',
    })
    public readonly eventTarget: Node = null;
    @property({ displayName: DEV && '觸發動畫名稱', tooltip: DEV && '觸發動畫名稱' })
    public readonly clipName: string = '';

    private _animation: EnhanceAnimation = null;

    protected onLoad(): void {
        this._animation = this.getComponent(EnhanceAnimation);
        const target = this.useEventTarget ? this.eventTarget : EnhanceAnimation.EVENT_TARGET;
        target.on(this.eventName, () => {
            this._animation?.play(this.clipName);
        });
    }
}
